module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0117.jpg?v=19f1893c";